import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=e5cf042c"
import script from "./Tiptap.vue?vue&type=script&lang=ts"
export * from "./Tiptap.vue?vue&type=script&lang=ts"
import style0 from "./Tiptap.vue?vue&type=style&index=0&id=e5cf042c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports